import { h } from 'vue'

export const StepChevronIcon = {
  name: 'StepChevronIcon',
  render: () => h('svg', {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true',
    focusable: 'false',
    class: 'shrink-0',
  }, [
    h('path', {
      d: 'M16.2265 12.8027L9.37701 19.6522C8.94891 20.1159 8.19975 20.1159 7.77165 19.6522C7.30789 19.2241 7.30789 18.4749 7.77165 18.0468L13.8006 11.9822L7.77165 5.95318C7.30789 5.52508 7.30789 4.77592 7.77165 4.34783C8.19975 3.88406 8.94891 3.88406 9.37701 4.34783L16.2265 11.1973C16.6903 11.6254 16.6903 12.3746 16.2265 12.8027Z',
      fill: 'currentColor',
    }),
  ]),
}
